import { FixedBgTextProps, FixedBgTextEditorProps, HtmlContent } from './FixedBgText.types';

/**
 * 기존 데이터 형식을 새로운 형식으로 변환
 * 
 * @param originalProps 기존 컴포넌트의 props
 * @returns 변환된 새로운 컴포넌트용 props
 */
export function adaptFixedBgTextProps(originalProps: any): FixedBgTextProps {
  // 기본값 설정 (빈 객체로 초기화)
  const originalComponentProps = originalProps?.componentProps || {};
  const originalStyle = originalProps?.style || {};
  const originalContent = originalProps?.content || {};
  
  // 레거시 속성 처리 (imageUrl, title, description)
  const imageUrl = originalProps?.imageUrl || '';
  const title = originalProps?.title || '';
  const description = originalProps?.description || '';
  
  // 뷰모드 추출
  const viewMode = originalProps?.viewMode || 'pc';
  const isMobile = viewMode === 'mobile' || viewMode === 'tablet';
  
  // 기본 컴포넌트 속성 설정
  const componentProps = {
    // 레거시 이미지 URL을 bgImageUrl로 변환
    bgImageUrl: originalComponentProps?.bgImageUrl || imageUrl || originalContent?.imageUrl || '',
    
    // 다른 속성들
    overlayColor: originalComponentProps?.overlayColor || '#000000',
    overlayOpacity: originalComponentProps?.overlayOpacity !== undefined ? originalComponentProps.overlayOpacity : 0.5,
    textColor: originalComponentProps?.textColor || '#ffffff',
    contentAlignment: originalComponentProps?.contentAlignment || 'center',
    height: originalComponentProps?.height || (isMobile ? 400 : 500),
    
    // 다른 속성들 복사
    ...originalComponentProps
  };

  // HTML 콘텐츠 처리
  let processedContent: string | HtmlContent = '';
  
  // content가 문자열인 경우 (단순 HTML)
  if (typeof originalProps.content === 'string') {
    processedContent = originalProps.content;
  }
  // content가 객체인 경우 (디바이스별 설정이 있는 경우)
  else if (originalProps.content && typeof originalProps.content === 'object') {
    const contentObj: HtmlContent = {};
    
    // deviceProperty가 있는 경우
    if (originalProps.content.deviceProperty) {
      contentObj.deviceProperty = { ...originalProps.content.deviceProperty };
    }
    
    // html 속성이 있는 경우
    if (originalProps.content.html) {
      contentObj.html = originalProps.content.html;
    }
    
    processedContent = contentObj;
  }
  
  // 원본 스타일 병합
  const style = {
    ...originalStyle
  };
  
  // 최종 props 구성
  const adaptedProps: FixedBgTextProps = {
    id: originalProps?.id || '',
    style,
    className: originalProps?.className || '',
    debug: originalProps?.debug || false,
    componentProps,
    content: processedContent,
    // 레거시 속성들도 유지
    imageUrl,
    title,
    description,
    viewMode,
    isPreview: originalProps?.isPreview || false
  };

  // 원본 props의 다른 속성들 복사 (이미 처리한 속성 제외)
  const excludeKeys = ['id', 'style', 'className', 'debug', 'componentProps', 'content', 
                      'imageUrl', 'title', 'description', 'viewMode', 'isPreview'];
  
  Object.keys(originalProps).forEach(key => {
    if (!excludeKeys.includes(key)) {
      adaptedProps[key] = originalProps[key];
    }
  });

  return adaptedProps;
}

/**
 * 에디터용 데이터 형식 변환
 * 
 * @param originalProps 기존 컴포넌트의 props
 * @returns 변환된 에디터 컴포넌트용 props
 */
export function adaptFixedBgTextEditorProps(originalProps: any): FixedBgTextEditorProps {
  // 기본 props 변환 사용
  const adaptedProps = adaptFixedBgTextProps(originalProps) as FixedBgTextProps;
  
  // 에디터 관련 추가 props
  return {
    ...adaptedProps,
    isSelected: originalProps.isSelected || false,
    updateComponent: originalProps.updateComponent || (() => {})
  };
} 